export const GET_RULES_ACTIONS_REQUEST = 'GET_RULES_ACTIONS_REQUEST';
export const GET_RULES_ACTIONS_SUCCESS = 'GET_RULES_ACTIONS_SUCCESS';
export const GET_RULES_ACTIONS_ERROR = 'GET_RULES_ACTIONS_ERROR';
export const ADD_RULES_ACTION_REQUEST = 'ADD_RULES_ACTION_REQUEST';
export const ADD_RULES_ACTION_SUCCESS = 'ADD_RULES_ACTION_SUCCESS';
export const ADD_RULES_ACTION_ERROR = 'ADD_RULES_ACTION_ERROR';
export const GET_RULES_ACTION_REQUEST = 'GET_RULES_ACTION_REQUEST';
export const GET_RULES_ACTION_SUCCESS = 'GET_RULES_ACTION_SUCCESS';
export const GET_RULES_ACTION_ERROR = 'GET_RULES_ACTION_ERROR';
export const UPDATE_RULES_ACTION_REQUEST = 'UPDATE_RULES_ACTION_REQUEST';
export const UPDATE_RULES_ACTION_SUCCESS = 'UPDATE_RULES_ACTION_SUCCESS';
export const UPDATE_RULES_ACTION_ERROR = 'UPDATE_RULES_ACTION_ERROR';
export const DELETE_RULES_ACTION_REQUEST = 'DELETE_RULES_ACTION_REQUEST';
export const DELETE_RULES_ACTION_SUCCESS = 'DELETE_RULES_ACTION_SUCCESS';
export const DELETE_RULES_ACTION_ERROR = 'DELETE_RULES_ACTION_ERROR';
export const UPDATE_RULES_ACTIONS_PAGINATION_PARAMS =
  'UPDATE_RULES_ACTIONS_PAGINATION_PARAMS';
